import {
  Preload,
  useContextBridge,
  Environment,
  Plane,
  Detailed,
} from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import Controls from 'componentsFor3D/Controls';
import ModelLoader from 'templateFor3D/ModelLoader';
import Part1 from 'componentsFor3D/Part1';
import Torus from 'componentsFor3D/Ring';
import ScreenVideo from 'componentsFor3D/ScreenVideo';

import { ControlContext } from 'provider/ControlProvider';
import { Suspense } from 'react';
import Ocean from 'componentsFor3D/Ocean';
import Sea from 'componentsFor3D/Sea';
import { Layers } from 'three';
import { EffectComposer, SelectiveBloom } from '@react-three/postprocessing';
export default function MapViewer() {
  const ContextBridge = useContextBridge(ControlContext);
  const layers = new Layers();
  layers.enable(1);
  // layers.enable(1);
  return (
    <Suspense fallback={null}>
      <Canvas
        performance={{ min: 0.5 }}
        camera={{
          position: [0, 3, 0],
          fov: 50,
          near: 0.001,
          layers: layers,
        }}
      >
        <ContextBridge>
          <ModelLoader
            url='special/book.glb'
            pos={[0, -0.728, -0.2]}
            rot={[0, -Math.PI / 2, 0]}
            scale={8.9}
          />
          <Environment
            files={'assets/env.hdr'}
            ground={{ height: 18, radius: 60, scale: 40 }}
          />
          <EffectComposer disableNormalPass>
            <SelectiveBloom
              selectionLayer={1}
              luminanceThreshold={0.9}
              intensity={2}
            />
          </EffectComposer>
          <group>
            <Torus pos={[-0.1, -0.03, -0.8]} />
            <Torus pos={[-0.1, -0.03, -0.4]} />
            <Torus pos={[-0.1, -0.03, 0]} />
            <Torus pos={[-0.1, -0.03, 0.4]} />
            <Torus pos={[-0.1, -0.03, 0.8]} />
            <Torus pos={[-0.1, -0.03, 1.2]} />
            <Torus pos={[-0.1, -0.03, 1.6]} />
          </group>
          <group position={[0.4, 0, 0]}>
            <Torus pos={[-0.1, -0.03, -0.8]} />
            <Torus pos={[-0.1, -0.03, -0.4]} />
            <Torus pos={[-0.1, -0.03, 0]} />
            <Torus pos={[-0.1, -0.03, 0.4]} />
            <Torus pos={[-0.1, -0.03, 0.8]} />
            <Torus pos={[-0.1, -0.03, 1.2]} />
            <Torus pos={[-0.1, -0.03, 1.6]} />
          </group>
          <Detailed distances={[0, 1, 2]}>
            <group>
              <Ocean scale={0.03} pos={[-0.8, 0.039, 0.29]} />
            </group>
            <Plane
              args={[0.3, 0.3]}
              rotation={[-Math.PI / 2, 0, 0]}
              position={[-0.8, 0.039, 0.29]}
            >
              <meshBasicMaterial color='#3743F1' />
            </Plane>
          </Detailed>
          <ambientLight intensity={0.07} />
          <pointLight position={[1.5, 0.2, 0]} intensity={0.7} distance={1} />
          <Part1 />
          <ModelLoader
            url='part2/part2.glb'
            pos={[1.6, -0.16, 0.2]}
            rot={[0, Math.PI / 2, 0]}
            scale={0.009}
          />
          <Detailed distances={[0, 2, 4]}>
            <group>
              <ModelLoader
                url='detailed/ship1.glb'
                pos={[1.6, 0.04, 0.2]}
                rot={[0, Math.PI / 2, 0]}
                scale={0.0005}
              />
              <ModelLoader
                url='detailed/treasure1.glb'
                pos={[0.7, 0.06, 0.5]}
                rot={[0, Math.PI / 2, 0]}
                scale={0.02}
              />
            </group>
            <group></group>
          </Detailed>
          <mesh position={[0.688, 0.152, 0.523]} scale={0.003} layers={1}>
            <sphereGeometry />
            <meshBasicMaterial color={'#FFFFFF'} toneMapped={false} />
            <pointLight intensity={1} color={'#9097F3'} distance={0.2} />
          </mesh>
          <Sea pos={[1.558, 0.03, 0.154]} scale={0.0000108} />
          <pointLight position={[2, 0.2, 0]} distance={0.6} intensity={2} />
          <pointLight position={[1.2, 0.2, 0]} distance={0.6} />
          <pointLight position={[1.6, 0.2, 0.4]} distance={0.6} />
          <pointLight position={[1.6, 0.2, -0.4]} distance={0.6} />
          <Controls />
        </ContextBridge>
        <Preload />
      </Canvas>
    </Suspense>
  );
}
